<template>
  <modal
    name="dialog"
    transition="pop-out"
    :clickToClose="buttons.secondary.active"
    height="auto"
    @before-open="beforeOpen"
    :scrollable="true"
    :pivotY="0.5"
  >
    <div class="modal modal-warning">
      <div class="modal-header">
        {{ title }}
        <iconClose
          v-if="buttons.secondary.active"
          class="icon-close"
          @click.native="$modal.hide('dialog')"
        ></iconClose>
      </div>
      <div class="modal-content">
        <div class="info">
          {{ content }}
        </div>
        <div class="selected-campsite" v-if="selectedCampsite">
          {{ selectedCampsite.name }}
        </div>
      </div>
      <div class="modal-footer">
        <CiGenericNavigation
          @clickPrimary="onProceed"
          @clickSecondary="onCancel"
          :ciClassesPrimary="buttons.primary.classes"
          :ciActiveSecondary="buttons.secondary.active"
        >
          <template slot="secondary">
            <iconArrowBlack class="icon icon--animated"></iconArrowBlack>
            <span>{{ $t('generic.buttons.abort') }}</span>
          </template>
          <template slot="primary">
            <span>{{
              buttons.primary.text ? buttons.primary.text : $t('generic.buttons.continue')
            }}</span>
            <iconArrowWhite class="icon icon--animated"></iconArrowWhite>
          </template>
        </CiGenericNavigation>
      </div>
    </div>
  </modal>
</template>

<script>
import { CiButton, CiGenericNavigation } from '@/components/index'

// icons
import iconArrowBlack from '@/assets/icons/arrow-black.svg'
import iconArrowWhite from '@/assets/icons/arrow-white.svg'
import iconClose from '@/assets/icons/close-dark.svg'

export default {
  name: 'CiModalDialog',
  components: {
    CiButton,
    CiGenericNavigation,
    iconArrowBlack,
    iconArrowWhite,
    iconClose,
  },
  data() {
    return {
      buttons: {
        primary: {
          active: true,
          classes: 'button--primary',
        },
        secondary: { active: true, classes: 'button--secondary' },
      },
      content: null,
      proceedEvent: null,
      selectedCampsite: null,
      title: null,
    }
  },
  methods: {
    beforeOpen(event) {
      if (event.params.buttons) this.buttons = event.params.buttons
      if (event.params.proceedEvent) this.proceedEvent = event.params.proceedEvent

      this.selectedCampsite = event.params.selectedCampsite || null
      this.content = event.params.content || null
      this.title = event.params.title || null
    },

    onCancel() {
      this.$modal.hide('dialog')
    },

    onProceed() {
      this.proceedEvent && this.proceedEvent()
      this.$modal.hide('dialog')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-content {
  margin: 0;

  @include media-breakpoint-up(md) {
    margin: 0 75px 0;
  }

  .selected-campsite {
    font-weight: bold;
    margin-top: 20px;
  }
}

.modal-footer {
  margin: 0 15px 0;

  @include media-breakpoint-up(md) {
    margin: 20px 75px 30px;
  }
}
</style>
